import React from "react";
import { Typography } from "antd";
import { Header } from "antd/es/layout/layout";
import ArrowBackIcon from "../../assets/svgs/svg-icons/ArrowBackIcon";
import { capitalizeWords, formatStr } from './../../utils/utils';
import { useNavigate } from "react-router-dom";
import HeaderActions from "./HeaderActions";

const SapaHeader = ({ page, showArrow = false }) => {
  const navigate = useNavigate();

  return (
    <Header className="Header">
      <div className="sapa-header__title">
       {/*  {showArrow && (
          <ArrowBackIcon onClick={() => setShowOverview(!showOverview)} />
        )} */}
         {showArrow && (
          <ArrowBackIcon onClick={() => navigate(-1)} />
        )}
        <Typography.Text>{capitalizeWords(formatStr(page))}</Typography.Text>
      </div>
      <HeaderActions />
    </Header>
  );
};

export default SapaHeader;
